import { createClient } from '@supabase/supabase-js';

export function supabaseBrowser() {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL as string;
  const anon = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY as string;
  if (!url || !anon) {
    // Return a dummy client-like object to avoid crashes if env missing
    throw new Error('Supabase env (NEXT_PUBLIC_SUPABASE_URL, NEXT_PUBLIC_SUPABASE_ANON_KEY) is not set');
  }
  return createClient(url, anon, {
    auth: { persistSession: true, autoRefreshToken: true },
  });
}
